import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section className="bg-gradient-to-b from-gray-950 to-gray-900 text-white py-16 px-4" data-id="element-56">
      <div className="max-w-4xl mx-auto text-center" data-id="element-57">
        <div className="bg-green-900 border-2 border-green-600 rounded-lg p-8 mb-8" data-id="element-58">
          <ShieldCheckIcon className="w-16 h-16 mx-auto mb-4 text-green-400" data-id="element-59" />
          <h2 className="text-3xl font-bold mb-4" data-id="element-60">🛡️ GARANTÍA TOTAL 7 DÍAS</h2>
          <p className="text-lg text-gray-200" data-id="element-61">
            Si en una semana no sentís más claridad, menos dolor y un plan
            concreto para el próximo domingo, te devolvemos el 100% del dinero.
            Sin preguntas. Sin formularios. Sin vueltas.
          </p>
        </div>

        <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-700 text-white font-bold text-xl px-12 py-5 rounded-lg shadow-2xl hover:shadow-green-600/50 transition-all duration-300 inline-flex items-center gap-2" data-id="element-62">
          ¡SÍ, QUIERO EL SISTEMA CICLISTA 360™!{' '}
          <ArrowRightIcon className="w-6 h-6" data-id="element-63" />
        </button>

        <p className="text-gray-400 mt-6" data-id="element-64">
          $19.990 ARS · Pago único · Acceso de por vida
        </p>
      </div>
    </section>;
}